import { initializeAlertRibbon } from './global/alert-ribbon.js';
import { initializeBackToTop } from './global/back-to-top.js';
import { initializeBackgroundVideos } from './global/background-video.js';
import { initializeDownloadLinks } from './global/download-links.js';
import { initializeExternalLinks } from './global/external-links.js';
import { initializeGlobalNavigation } from './global/navigation.js';
import { loadNearViewport } from './global/load-near-viewport.js';
import { initializeSmoothScrolling } from './global/smooth-scrolling.js';

initializeAlertRibbon();
initializeBackToTop();
initializeBackgroundVideos();
initializeDownloadLinks();
initializeExternalLinks();
initializeGlobalNavigation();
initializeSmoothScrolling();

// Load Splide shortly before the first carousel enters the viewport.
loadNearViewport(
  '[data-gallery-carousel], .banner-carousel, .testimonials-carousel',
  () => {
    import('./components/carousels.js').then(({ initializeCarousels }) => initializeCarousels());
  },
);

loadNearViewport('.gallery, .card-gallery, .open-popup-link', () => {
  import('./components/lightbox.js').then(({ initializeLightbox }) => initializeLightbox());
}, '100px 0px');

loadNearViewport('[data-aos]', () => {
  import('./components/scroll-animations.js').then(({ initializeScrollAnimations }) => initializeScrollAnimations());
}, '400px 0px');

loadNearViewport('.js-tabs, .js-tabs-faq', () => {
  import('./components/accordion-tabs.js').then(({ initializeAccordionTabs }) => initializeAccordionTabs());
}, '400px 0px');

loadNearViewport('.js-video-facade', () => {
  import('./components/video-facades.js').then(({ initializeVideoFacades }) => initializeVideoFacades());
}, '100px 0px');
